const ConnectwiseConnect = () => import('@/views/account/integrations/connectwise/connectwise-connect-view.vue');
const ConnectwiseManage = () => import('@/views/account/integrations/connectwise/connectwise-manage-view');

import store from '@/stores/index';

import ConnectWiseMappingRoutes from '@/routes/integrations/connectwise/mapping';
import ConnectWiseImportRoutes from '@/routes/integrations/connectwise/import';

export default [
    {
        path: '/Integrations/ConnectWise/Manage',
        name: 'ConnectwiseManage',
        component: ConnectwiseManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Connectwise Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage',
        name: 'ClientConnectwiseManage',
        component: ConnectwiseManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Connectwise Integration'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Connection',
        name: 'ConnectwiseConnect',
        component: ConnectwiseConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Connectwise Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Connection',
        name: 'ClientConnectwiseConnect',
        component: ConnectwiseConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Connectwise Integration'
        }
    },
    ...ConnectWiseMappingRoutes,
    ...ConnectWiseImportRoutes
]